import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Box, 
  CardActionArea,
  Avatar
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)(({ theme, selected }) => ({
  marginBottom: theme.spacing(2),
  transition: theme.transitions.create(['transform', 'box-shadow', 'border']),
  border: selected ? `2px solid ${theme.palette.primary.main}` : '2px solid transparent',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: theme.shadows[3],
  },
}));

const OrganizationAvatar = styled(Avatar)(({ theme }) => ({
  width: 48,
  height: 48,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  fontWeight: 'bold',
  fontSize: '1.2rem',
}));

const CardContentWrapper = styled(CardContent)({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  padding: '16px !important', // Override MUI's padding
});

/**
 * Organization card component
 * @param {Object} props Component props
 * @param {string} props.id Organization ID
 * @param {string} props.name Organization name
 * @param {boolean} props.selected Whether this organization is selected
 * @param {Function} props.onClick Click handler
 * @returns {JSX.Element} OrganizationCard component
 */
const OrganizationCard = ({ 
  id, 
  name, 
  selected = false, 
  onClick 
}) => {
  // Generate initials from organization name
  const getInitials = (name) => {
    if (!name) return '?';
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <StyledCard selected={selected} elevation={selected ? 2 : 1}>
      <CardActionArea onClick={onClick}>
        <CardContentWrapper>
          <OrganizationAvatar>
            {getInitials(name)}
          </OrganizationAvatar>
          <Box>
            <Typography variant="h6" component="div" noWrap>
              {name}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              ID: {id}
            </Typography>
          </Box>
        </CardContentWrapper>
      </CardActionArea>
    </StyledCard>
  );
};

export default OrganizationCard;
